import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import {
  Card,
  CardContent,
  CardHeader,
  IconButton,
  Typography,
  Box,
  Chip,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const STORAGE_KEY = 'cynthia_welcomed';

const WelcomeCard = ({ limit: limitProp } = {}) => {
  const selectedTenant = useSelector((state) => state.user.selectedTenant);
  const limit = limitProp ?? selectedTenant?.admission_limit ?? 20;
  const [visible, setVisible] = useState(() => !localStorage.getItem(STORAGE_KEY));

  const handleDismiss = () => {
    localStorage.setItem(STORAGE_KEY, 'true');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <Card variant="outlined" sx={{ mb: 2 }}>
      <CardHeader
        title="Welcome to Cynthia"
        titleTypographyProps={{ variant: 'subtitle1', fontWeight: 600 }}
        action={
          <IconButton size="small" onClick={handleDismiss} aria-label="dismiss welcome card">
            <CloseIcon fontSize="small" />
          </IconButton>
        }
        sx={{ pb: 0 }}
      />
      <CardContent sx={{ pt: 1 }}>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          You have {limit} free records to generate. Pick a record type below, configure your
          population, and hit Generate. Your records download instantly as CSV, JSON, or FHIR.
        </Typography>
        <Box sx={{ display: 'flex', gap: 1, mt: 1.5, flexWrap: 'wrap' }}>
          <Chip label="1. Choose type" size="small" variant="outlined" />
          <Chip label="2. Configure" size="small" variant="outlined" />
          <Chip label="3. Download" size="small" variant="outlined" />
        </Box>
      </CardContent>
    </Card>
  );
};

export default WelcomeCard;
